import { Switch } from 'antd';
import {
  displayErrorNotification,
  displaySuccessNotification
} from '../../../../utils/displayNudosStandardNotifications';
import { updateCare } from '../../../../services/bussines';
import { useEffect, useState } from 'react';
import { NUDOS_CARE_ID } from '../../../../types/nudosCare.types';

const SwitchChangeCare = ({
  isFullCare,
  productId,
  updateDataCallback
}: {
  isFullCare: boolean;
  productId: number;
  updateDataCallback: () => Promise<void>;
}) => {
  const [isActive, setIsActive] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleChangeCare = async () => {
    const newState = !isActive;
    setIsActive(newState);
    setIsLoading(true);

    try {
      if (!isActive) {
        await updateCare([{ nudosCare: NUDOS_CARE_ID.FULL, productId: productId }]);
        displaySuccessNotification({
          customJSXMessage: (
            <>Care asociado con éxito. Ahora puedes agregar configuraciones adicionales a la herramienta</>
          )
        });
      } else {
        await updateCare([{ nudosCare: NUDOS_CARE_ID.FREE, productId: productId }]);
        displaySuccessNotification({
          customJSXMessage: <>Care desvinculado con éxito</>
        });
      }
      await updateDataCallback();
    } catch (error) {
      setIsActive(!newState);
      displayErrorNotification({
        customJSXMessage: <>Error al actualizar el care</>
      });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    setIsActive(isFullCare);
  }, [isFullCare]);

  return (
    <div id="customSwitch">
      <Switch
        checked={isActive}
        onChange={handleChangeCare}
        style={{ width: 'max-content', height: '24px' }}
        checkedChildren="Con Care"
        unCheckedChildren="Sin Care"
        loading={isLoading}
      />
    </div>
  );
};

export default SwitchChangeCare;
